import React, { Component } from 'react';
import request from 'superagent';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import moment from 'moment';
import ToolBar from '../../commons/ToolBar.js';
import Loading from '../../commons/Loading.js';
import Detail from './MultiTenantServiceDetail.js';
import {PermissionCtrl} from "../../commons/CommonUtils";
import {Permissions} from "../../commons/Constants";
import NotificationManager from '../../commons/CustomNotificationManager.js';

class MultiTenantServiceView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dataList: [],
            loading: true,
            selected: null,
            containerHeight: 2000
        };
    }

    getMultiTenantServiceList = () => {
        return request.get('/scaler/multiTenantService').withCredentials()
            .then(response => {
                this.setState({
                    dataList: response.body.serviceList
                });
            });
    }

    componentDidMount() {
        this.init();
    }

    init = () => {
        //this.refs.table.cleanSelected();
        this.setState({loading: true, dataList: [], selected: null});
        this.getMultiTenantServiceList()
            .then(() => {
                this.setState({loading: false});
            })
            .then(() => {
                const height = document.getElementById('container').clientHeight - 110;
                this.setState({containerHeight: height});
            })
            .catch(err => {
                console.error('Failed to fetch MultiTenantServices', err);
                NotificationManager.error('Failed to fetch MultiTenantServices');
                this.setState({
                    dataList: [],
                    loading: false,
                    selected: null
                });
            })
    }

    refreshTable = (currentObj) => {
        return this.getMultiTenantServiceList()
            .then(() => {
                if (currentObj !== null) {
                    let list = this.state.dataList;
                    list = list.filter(s => s.serviceName === currentObj.serviceName && s.serviceVersion === currentObj.serviceVersion);
                    if (list.length === 1) {
                        this.setState({selected: list[0]});
                        return list[0];
                    }
                } else {
                    this.setState({selected: null});
                }
            })
    }

    createCustomToolBar = props => {
        return (
            <div>
                <PermissionCtrl permission={[Permissions.MultiTenant.SCALE]}>
                <div className='buttonFiled' style={{ display: this.state.selected === null ? 'block' : 'none' }}>
                    <ToolBar onFresh={this.init}/>
                </div>
                </PermissionCtrl>
                <div className='searchFiled' style={{width: this.state.selected === null  ? '': '100%'}}>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    stateFormat = (cell) => {
        if (cell === "active") {
            return (
                <div className="serviceState" style={{backgroundColor: "#30a83a"}}>
                </div>
            );
        } else if (cell === "shutdown") {
            return (
                <div className="serviceState" style={{backgroundColor: "#9e9e9e"}}>
                </div>
            );
        } else if (cell === "deploying") {
            return (
                <div>
                    <i class="anticon anticon-spin anticon-loading">Deploying</i>
                </div>
            );
        } else if (cell === "draining") {
            return (
                <div >
                    <i class="anticon anticon-spin anticon-loading">Draining</i>
                </div>
            );
        } else {
            return cell;
        }
    }

    closeDetail = () => {
        this.setState({selected: null});
    }

    nameFormat = (cell, row) => {
        return <a onClick={() => this.setState({selected: row})}><div>{cell}</div></a>
    }

    instanceFormat = (cell, row) => {
        if (cell) {
            return cell.length;
        } else {
            return '';
        }
    }

    timeFormat = (cell, row) => {
        if (cell && cell.length > 0) {
            return cell.map(i => moment(i["marathonStartedAt"]).fromNow()).join(" | ");
        } else {
            return '';
        }
    }

    trClassFormat = (row, rowIndex) => {
        const s = this.state.selected;
        if (s !== null && row.serviceName === s.serviceName && row.serviceVersion === s.serviceVersion) {
            return "table_selected_row";
        }
    };

    render = () => {
        const {dataList, loading, selected, containerHeight} = this.state;
        const options = {
            defaultSortName: 'serviceName',
            defaultSortOrder: 'asc',
            noDataText: loading ? <Loading /> : 'No service found.',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500
        };

        return (
            <div className="page-container">
                <div id="container" className={`${selected === null ? 'col-md-12': 'col-md-5'} list`}>
                    <h2 className="page-title">Services</h2>
                    <BootstrapTable ref="table" trClassName={this.trClassFormat}
                                    data={ dataList } search={ true } options={ options }
                                    bodyStyle={{ overflowX: 'hidden' }} maxHeight={containerHeight}
                                    multiColumnSearch={ true }
                                    striped hover condensed>
                        <TableHeaderColumn dataField='state'
                                           headerAlign='left'
                                           dataAlign="center"
                                           dataFormat={this.stateFormat}
                                           width="80px">
                            State
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='serviceName'
                                           dataFormat={this.nameFormat}
                                           dataSort={ true } isKey>
                            Service Name
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='serviceVersion'
                                           dataSort={ true }
                                           hidden={selected !== null}>
                            Service Version
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='version'
                                           dataSort={ true }
                                           hidden={selected !== null}>
                            Version
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='instances'
                                           dataFormat={this.instanceFormat}
                                           filterFormatted={ true }
                                           hidden={selected !== null}>
                            Instances
                        </TableHeaderColumn>
                        <TableHeaderColumn dataField='instances'
                                           dataFormat={this.timeFormat}
                                           filterFormatted={ true }
                                           hidden={selected !== null}>
                            Started At
                        </TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <div id="detailContainer" className={`${selected === null ? 'col-md-0': 'col-md-7'} detailInfo`}>
                    {selected === null ? ('') : (
                        <Detail close={this.closeDetail} service={selected} refresh={this.refreshTable}/>
                    )}
                </div>
            </div>
        );
    }
}

export default MultiTenantServiceView;


// WEBPACK FOOTER //
// ./src/modules/multi-tenanted-service/MultiTenantServiceView.js